/* Max Rive homepage atlas. No map API, tracking, external library or scroll-wheel capture. */
(()=>{
 'use strict';
 if(window.MRHomeAtlas)return;
 const SVG='http://www.w3.org/2000/svg';
 let instance=0;
 function mount(root){
  if(root.dataset.atlasReady)return;
  const configNode=root.querySelector('[data-atlas-data]');
  let config;try{config=JSON.parse(configNode.textContent)}catch(_){return}
  if(!config.destinations?.length)return;
  root.dataset.atlasReady='true';
  const get=k=>root.querySelector('[data-atlas-'+k+']');
  const stage=get('stage'),plane=get('plane'),pins=get('pins'),labels=get('labels'),leaders=get('leaders');
  const card=get('card'),photo=get('photo'),picker=get('picker');
  const data=config.destinations,ratio=config.width/config.height;
  const buttons=[...root.querySelectorAll('[data-atlas-region]')];
  const media=matchMedia('(max-width:760px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const hoverable=matchMedia('(any-hover:hover) and (any-pointer:fine)');
  const listeners=[];const listen=(el,event,fn,opts)=>{el.addEventListener(event,fn,opts);listeners.push(()=>el.removeEventListener(event,fn,opts))};
  let sw=0,sh=0,bw=0,bh=0,tx=0,ty=0,z=1,region='world',selected=null,frame=0,drag=null,suppressClick=false;
  let focusBack=null,ready=false,selectionMode=null,leaveTimer=0,restoringFocus=false,lastPointer='mouse';
  let dock={left:28,bottom:13,width:246,height:306};
  card.id=card.id||'MRAtlasPreview-'+(++instance);
  function cancelClose(){clearTimeout(leaveTimer);leaveTimer=0}
  function hasPreviewFocus(){
   const el=document.activeElement;
   return card.contains(el)||(selectionMode==='focus'&&el===focusBack)||(selectionMode==='picker'&&el===picker);
  }
  function scheduleClose(){
   cancelClose();
   if(selectionMode==='touch')return;
   // A brief bridge lets the pointer travel from a marker to the fixed preview link.
   leaveTimer=setTimeout(()=>{
    leaveTimer=0;
    if(selectionMode==='touch'||card.matches(':hover')||root.querySelector('.atlas-pin:hover,.atlas-label:hover')||hasPreviewFocus())return;
    close(false);
   },360);
  }
  function updateHint(){
   const action=hoverable.matches?'Hover over':'Tap';
   get('hint').textContent=region==='world'?action+' a destination to preview its gallery':action+' a gallery · Drag to explore';
  }
  const nodes=new Map();
  // Offsets keep the Alpine galleries separate while every dot stays at its true location.
  const offsets={
   'dolomites':[56,-30],'switzerland':[-42,-62],'french-alps':[-72,-25],
   'spain':[-66,24],'madeira':[-37,47],'iceland-1':[-38,-24],
   'norway':[33,-21],'greenland':[-22,-29],'cappadocia':[67,4],
   'saudi-arabia':[39,33],'kazakhstan-mangystau':[30,-28],
   'nepal':[31,30],'china':[36,-14],'new-zealand':[-49,32],
   'patagonia':[-39,26],'peru':[-32,-17],'usa':[-17,-24]
  };
  const validURL=raw=>{try{const u=new URL(raw,location.href);return ['http:','https:','file:'].includes(u.protocol)?raw:'#'}catch(_){return '#'}};
  function activeData(){return region==='world'?data:data.filter(d=>d.region===region)}
  data.forEach(d=>{
   const pin=document.createElement('a');pin.className='atlas-pin js-no-transition';pin.href=validURL(d.url);pin.dataset.destination=d.id;
   pin.setAttribute('aria-label',d.name+' gallery');pin.setAttribute('aria-expanded','false');pin.setAttribute('aria-controls',card.id);
   const dot=document.createElement('span');dot.className='atlas-dot';dot.setAttribute('aria-hidden','true');pin.append(dot);pins.append(pin);
   const label=document.createElement('a');label.className='atlas-label js-no-transition';label.href=validURL(d.url);label.textContent=d.name;label.dataset.destination=d.id;
   label.setAttribute('aria-label',d.name+' gallery');label.setAttribute('aria-controls',card.id);label.tabIndex=-1;labels.append(label);
   const line=document.createElementNS(SVG,'line');leaders.append(line);
   function preview(e){
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    if(suppressClick){e.preventDefault();return}
    // Mouse/keyboard activation follows the real gallery link. Touch still opens a preview.
    const pointer=e.pointerType||lastPointer;
    if(e.detail===0||(hoverable.matches&&pointer!=='touch'))return;
    e.preventDefault();focusBack=e.currentTarget;select(d.id,'touch');
   }
   [pin,label].forEach(el=>{
    listen(el,'click',preview);
    listen(el,'pointerdown',e=>{lastPointer=e.pointerType||'mouse'});
    listen(el,'pointerenter',e=>{
     lastPointer=e.pointerType||'mouse';
     if(e.pointerType==='touch'||!hoverable.matches||drag?.moved)return;
     focusBack=el;select(d.id,'hover');
    });
    listen(el,'pointerleave',e=>{if(e.pointerType!=='touch')scheduleClose()});
    listen(el,'focus',()=>{
     if(restoringFocus||!el.matches(':focus-visible'))return;
     focusBack=el;select(d.id,'focus');
    });
    listen(el,'blur',scheduleClose);
   });
   nodes.set(d.id,{pin,label,line,w:0,h:0});
  });
  function point(d){return {x:tx+d.x*bw*z,y:ty+d.y*bh*z}}
  function viewBounds(){return {w:bw*z,h:bh*z}}
  function clampView(){
   const v=viewBounds();
   tx=v.w<=sw?(sw-v.w)/2:Math.min(50,Math.max(sw-v.w-50,tx));
   ty=v.h<=sh?(sh-v.h)/2:Math.min(85,Math.max(sh-v.h-45,ty));
  }
  function readDock(){
   if(media.matches)return;
   const style=getComputedStyle(card);
   dock={left:parseFloat(style.getPropertyValue('--atlas-dock-left'))||28,
    bottom:parseFloat(style.getPropertyValue('--atlas-dock-bottom'))||13,
    width:parseFloat(style.width)||246,height:parseFloat(style.height)||306};
  }
  function placeCard(){
   if(media.matches)return null;
   // Fixed to the map's lower-left hint area, never to a destination or the browser viewport.
   const x=dock.left,y=Math.max(14,sh-dock.height-dock.bottom);
   card.style.left=x+'px';card.style.top=y+'px';
   // Reserve the same label area even while hidden: hover must never make labels jump.
   return {left:x-8,right:x+dock.width+8,top:y-8,bottom:y+dock.height+8};
  }
  function intersects(a,b){return a.left<b.right&&a.right>b.left&&a.top<b.bottom&&a.bottom>b.top}
  function placeLabels(cardBox){
   const active=activeData(),occupied=[];
   if(cardBox)occupied.push(cardBox);
   occupied.push({left:sw-139,right:sw,top:0,bottom:58});
   const pts=active.map(d=>point(d));
   // Tackle the dense central-European labels first, before they lose their available space.
   const order=['switzerland','dolomites','french-alps','spain','madeira'];
   const sorted=[...active].sort((a,b)=>{
    const ia=order.indexOf(a.id),ib=order.indexOf(b.id);return (ia<0?99:ia)-(ib<0?99:ib);
   });
   data.forEach(d=>{const n=nodes.get(d.id);n.label.hidden=true;n.line.style.display='none'});
   sorted.forEach(d=>{
    const n=nodes.get(d.id),p=point(d);
    if(p.x<8||p.x>sw-8||p.y<14||p.y>sh-30)return;
    n.label.hidden=false;
    const w=n.label.offsetWidth,h=n.label.offsetHeight;
    const prefer=offsets[d.id]||[32,-22];
    let candidates=[prefer,[w/2+13,0],[-w/2-13,0],[0,-23],[0,25],[w/2+12,-26],[-w/2-12,-26],[w/2+14,30],[-w/2-14,30]];
    if(z>2.1)candidates=[[w/2+14,-2],[0,27],[0,-25],prefer,...candidates];
    if(!media.matches){for(let r=48;r<=108;r+=20)for(const a of [-90,-45,0,45,90,135,180,225])candidates.push([Math.cos(a*Math.PI/180)*r,Math.sin(a*Math.PI/180)*r]);}
    let chosen=null;
    for(const [dx,dy] of candidates){
     const x=Math.min(sw-w/2-8,Math.max(w/2+8,p.x+dx));
     const y=Math.min(sh-h/2-35,Math.max(h/2+14,p.y+dy));
     const r={left:x-w/2-3,right:x+w/2+3,top:y-h/2-2,bottom:y+h/2+2};
     if(occupied.some(b=>intersects(r,b))||pts.some(o=>o.x>r.left-3&&o.x<r.right+3&&o.y>r.top-4&&o.y<r.bottom+4))continue;
     if(media.matches&&z<1.4&&Math.hypot(x-p.x,y-p.y)>65)continue;
     chosen={x,y,r};break;
    }
    if(!chosen){n.label.hidden=true;return}
    occupied.push(chosen.r);n.label.style.left=chosen.x+'px';n.label.style.top=chosen.y+'px';
    const ex=Math.max(chosen.x-w/2+3,Math.min(chosen.x+w/2-3,p.x));
    const ey=Math.max(chosen.y-h/2+3,Math.min(chosen.y+h/2-3,p.y));
    if(Math.hypot(ex-p.x,ey-p.y)>18){
     n.line.setAttribute('x1',p.x);n.line.setAttribute('y1',p.y);n.line.setAttribute('x2',ex);n.line.setAttribute('y2',ey);n.line.style.display='';
    }
   });
  }
  function draw(){
   if(!sw||!sh)return;
   plane.style.width=bw+'px';plane.style.height=bh+'px';plane.style.transform=`translate(${tx}px,${ty}px) scale(${z})`;
   data.forEach(d=>{
    const n=nodes.get(d.id),p=point(d),on=(region==='world'||d.region===region)&&p.x>-20&&p.x<sw+20&&p.y>-20&&p.y<sh+20;
    n.pin.hidden=!on;n.pin.tabIndex=on?0:-1;n.pin.style.left=p.x+'px';n.pin.style.top=p.y+'px';
   });
   root.querySelectorAll('[data-atlas-ocean]').forEach(el=>{
    const xy=el.dataset.atlasOcean.split(',').map(Number),p={x:tx+xy[0]*bw*z,y:ty+xy[1]*bh*z};
    el.hidden=region!=='world'||z>1.4;el.style.left=p.x+'px';el.style.top=p.y+'px';
   });
   const box=placeCard();placeLabels(box);
   get('minus').disabled=z<=1.001;get('plus').disabled=z>=5.99;
  }
  function setView(view,animate){
   cancelAnimationFrame(frame);
   if(!animate||reduced.matches){({tx,ty,z}=view);clampView();draw();return}
   const from={tx,ty,z},start=performance.now();
   const tick=now=>{
    const t=Math.min(1,(now-start)/430),e=1-Math.pow(1-t,3);
    tx=from.tx+(view.tx-from.tx)*e;ty=from.ty+(view.ty-from.ty)*e;z=from.z+(view.z-from.z)*e;draw();
    if(t<1)frame=requestAnimationFrame(tick);else{clampView();draw()}
   };frame=requestAnimationFrame(tick);
  }
  function fitted(name){
   if(name==='world')return {z:1,tx:(sw-bw)/2,ty:(sh-bh)/2};
   const ds=data.filter(d=>d.region===name);
   if(!ds.length)return fitted('world');
   let xmin=Math.min(...ds.map(d=>d.x)),xmax=Math.max(...ds.map(d=>d.x));
   let ymin=Math.min(...ds.map(d=>d.y)),ymax=Math.max(...ds.map(d=>d.y));
   const cx=(xmin+xmax)/2,cy=(ymin+ymax)/2;
   const spanx=Math.max(.12,xmax-xmin),spany=Math.max(.21,ymax-ymin);
   const zoom=Math.min(5,Math.max(1.35,Math.min((sw-150)/(spanx*bw),(sh-165)/(spany*bh))));
   return {z:zoom,tx:sw/2-cx*bw*zoom,ty:sh/2-cy*bh*zoom};
  }
  function setRegion(name,animate=true){
   region=name;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.atlasRegion===name)));
   close(false);setView(fitted(name),animate);
   const count=activeData().length;get('announcement').textContent=(name==='world'?'World':name)+' view. '+count+' galleries.';
   updateHint();
  }
  function select(id,mode='touch'){
   const d=data.find(d=>d.id===id);if(!d)return;
   cancelClose();selectionMode=mode;
   if(selected===id&&!card.hidden)return;
   if(region!=='world'&&d.region!==region){region=d.region;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.atlasRegion===region)));setView(fitted(region),false)}
   selected=id;picker.value=id;
   get('title').textContent=d.name;get('area').textContent=d.area;get('description').textContent=d.description;
   get('visit').href=validURL(d.url);get('visit').setAttribute('aria-label','View '+d.name+' gallery');
   photo.alt=d.name+' landscape photographed by Max Rive';
   if(photo.getAttribute('src')!==d.image){
    card.classList.add('is-loading');photo.src=d.image;
    if(photo.complete&&photo.naturalWidth)card.classList.remove('is-loading');
   }
   card.hidden=false;root.classList.add('has-atlas-preview');card.setAttribute('aria-label',d.name+' gallery preview');
   data.forEach(item=>{const n=nodes.get(item.id);n.pin.setAttribute('aria-expanded',String(item.id===id));n.label.setAttribute('aria-current',String(item.id===id))});
   get('announcement').textContent=d.name+'. '+d.description+' View gallery link is available.';
   const p=point(d);if(mode!=='hover'&&(p.x<30||p.x>sw-30||p.y<40||p.y>sh-35)){tx=sw/2-d.x*bw*z;ty=sh/2-d.y*bh*z;clampView()}
   draw();
  }
  function close(restoreFocus=true){
   cancelClose();selectionMode=null;selected=null;card.hidden=true;root.classList.remove('has-atlas-preview');picker.value='';
   data.forEach(d=>{const n=nodes.get(d.id);n.pin.setAttribute('aria-expanded','false');n.label.removeAttribute('aria-current')});
   draw();
   if(restoreFocus&&focusBack?.isConnected){
    restoringFocus=true;focusBack.focus({preventScroll:true});restoringFocus=false;
   }
  }
  function zoomBy(factor){
   const nz=Math.max(1,Math.min(6,z*factor));
   const cx=(sw/2-tx)/(bw*z),cy=(sh/2-ty)/(bh*z);
   close(false);setView({z:nz,tx:sw/2-cx*bw*nz,ty:sh/2-cy*bh*nz},true);
  }
  function measure(){
   const w=stage.clientWidth,h=stage.clientHeight;if(w<1||h<1)return;
   if(w===sw&&h===sh&&ready)return;
   sw=w;sh=h;bw=sw*.985;bh=bw/ratio;readDock();
   const view=fitted(region);({tx,ty,z}=view);clampView();draw();ready=true;
  }
  buttons.forEach(b=>listen(b,'click',()=>setRegion(b.dataset.atlasRegion)));
  listen(get('reset'),'click',()=>setRegion('world'));
  listen(get('plus'),'click',()=>zoomBy(1.4));listen(get('minus'),'click',()=>zoomBy(1/1.4));
  listen(get('close'),'click',()=>close());
  listen(picker,'change',()=>{if(picker.value){focusBack=picker;select(picker.value,hoverable.matches?'picker':'touch')}else close(false)});
  listen(picker,'blur',scheduleClose);
  listen(card,'pointerenter',cancelClose);
  listen(card,'pointerleave',e=>{if(e.pointerType!=='touch')scheduleClose()});
  listen(card,'focusin',cancelClose);listen(card,'focusout',scheduleClose);
  listen(root,'pointerleave',e=>{
   if(e.pointerType!=='touch'&&selectionMode!=='touch'&&!hasPreviewFocus())close(false);
  });
  listen(window,'blur',()=>{if(selectionMode==='hover')close(false)});
  listen(hoverable,'change',()=>{close(false);updateHint()});
  listen(root,'keydown',e=>{if(e.key==='Escape'&&!card.hidden){e.preventDefault();close()}});
  listen(photo,'load',()=>{card.classList.remove('is-loading')});
  listen(photo,'error',()=>{card.classList.remove('is-loading')});
  // Mouse dragging is local to the map. Touch keeps vertical page scrolling available.
  listen(stage,'pointerdown',e=>{
   if(e.button!==0||e.target.closest('a,button,select'))return;
   cancelAnimationFrame(frame);drag={id:e.pointerId,x:e.clientX,y:e.clientY,tx,ty,moved:false,touch:e.pointerType==='touch'};
   if(!drag.touch)stage.setPointerCapture(e.pointerId);
  });
  listen(stage,'pointermove',e=>{
   if(!drag||drag.id!==e.pointerId)return;
   const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
   if(!drag.moved&&Math.hypot(dx,dy)<6)return;
   if(drag.touch&&!root.hasAttribute('data-atlas-modal')&&!drag.moved&&Math.abs(dy)>Math.abs(dx)){drag=null;return}
   if(!drag.moved){drag.moved=true;stage.classList.add('is-dragging');close(false);if(drag.touch)stage.setPointerCapture(e.pointerId)}
   tx=drag.tx+dx;ty=drag.ty+dy;clampView();draw();
  });
  function endDrag(){if(drag?.moved){suppressClick=true;setTimeout(()=>{suppressClick=false},50)}drag=null;stage.classList.remove('is-dragging')}
  listen(stage,'pointerup',endDrag);listen(stage,'pointercancel',endDrag);listen(stage,'lostpointercapture',endDrag);
  const resize=new ResizeObserver(measure);resize.observe(stage);
  measure();updateHint();
  root.atlasCleanup=()=>{cancelClose();cancelAnimationFrame(frame);resize.disconnect();listeners.forEach(f=>f());delete root.dataset.atlasReady};
 }
 const pending = new Map();
 function queue(root) {
  if (!document.body.classList.contains('template-index') || root.hasAttribute('data-atlas-modal') || window.Shopify?.designMode || !('IntersectionObserver' in window)) { mount(root); return; }
  if (root.dataset.atlasReady || pending.has(root)) return;
  const start = () => {
   observer.disconnect(); pending.delete(root);
   root.removeEventListener('focusin', start); root.removeEventListener('pointerdown', start);
   mount(root);
  };
  const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) start(); }, {rootMargin:'600px 0px'});
  pending.set(root, () => { observer.disconnect(); root.removeEventListener('focusin', start); root.removeEventListener('pointerdown', start); });
  observer.observe(root);
  root.addEventListener('focusin', start, {once:true});
  root.addEventListener('pointerdown', start, {once:true,passive:true});
 }
 function init(scope){if(scope.matches?.('[data-mr-home-atlas]'))queue(scope);scope.querySelectorAll('[data-mr-home-atlas]').forEach(queue)}
 window.MRHomeAtlas={init};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-mr-home-atlas]').forEach(root=>{pending.get(root)?.();pending.delete(root);root.atlasCleanup?.()}));
})();
